module.exports = __webpack_public_path__ + "static/media/Buzz2.c839ae64.jpg";